import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { allMembersValue } from "./FilterMemberType";
import styles from "../staff.module.scss";
import ConfirmRemoveModal from "./modals/ConfirmRemoveModal";
import constants from "../../../constants";
import StaffActionModal from "components/StaffActionModal";
import {
  commonSelectedIntial,
  setterCommonValues,
} from "./StaffCard/staffActions.function";
import { cloneDeep } from "lodash";
import staffRepository, { uploadStaffCsv } from "repositories/staff-repository";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { decodeId, encodeId } from "utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import FailureSuccessRecordsModal from "./FailureSuccessRecordsModal";

const StaffListingActions = ({
  t,
  downloadAllExportFile,
  allSelectedData,
  globalStaffPage,
  selectedId,
  officeId,
  resetApi,
}) => {
  const officeIdDecode = officeId ? +decodeId(officeId) : null;
  const { isStaff, isOwner,selectedOwnerIdString } = useAccountOwnerCommon();
  const [isModalOpen, setIsModalOpen] = useState(null); // holds either constants events or our custom strings
  const dispatch = useDispatch();
  const officeDetail = useSelector((state) => state.offices.officeDetail);
  const modalSetter = useCallback((val) => setIsModalOpen(val), []);
  const history = useHistory();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggle = useCallback(() => setIsDropdownOpen((prev) => !prev), []);
  const boxRef = useRef(null);
  const fileInputRef = useRef(null);
  const [modalOpenForAll, setModalOpenForAll] = useState(null);
  const handleOutsideClick = (event) => {
    if (boxRef.current && !boxRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  const loadingSetter = (started) => {
    if (started) {
      dispatch({ type: "STAFFACTIONLOADINGSTARTED" });
    } else {
      dispatch({ type: "STAFFACTIONLOADINGSTOPPED" });
    }
  };
  const {
    selectedActivated,
    selectedActivatedAdmin,
    selectedDeactivated,
    selectedInvitationPending,
    selectedInvitationDeclined,
    selectedActivatedAndDeactivate,
    selectedActivatedAndDeactivateAllAdmins,
    selectedRemoved,
  } = useMemo(() => {
    // staff {type}
    // 1=> activated
    // 2=> deactivated
    // 3=> invitation pending
    // 4=> invitation declined
    const initalData = cloneDeep(commonSelectedIntial);
    return allSelectedData.reduce((prev, curr) => {
      if (globalStaffPage) {
        curr.officeList.forEach((userCurr) => {
          if (isStaff && userCurr.isAdmin) return;
          userCurr.staffMemberId = curr.userId;
          userCurr.firstName = curr.firstName;
          userCurr.lastName = curr.lastName;
          userCurr.profilePic = curr.profilePic;
          setterCommonValues(prev, userCurr);
        });
      } else {
        if (isStaff && curr.isAdmin) return prev;
        curr.officeId = officeIdDecode;
        setterCommonValues(prev, curr);
      }
      return prev;
    }, initalData);
  }, [allSelectedData, officeIdDecode, isStaff]);

  const activateDeactivateStaff = async (isActive) => {
    loadingSetter(true);
    try {
      const { UserIds, OfficeIds } = (
        isActive ? selectedDeactivated : selectedActivated
      ).reduce(
        (prev, curr) => {
          prev.UserIds.push(curr.staffMemberId);
          prev.OfficeIds.push(curr.officeId);
          return prev;
        },
        {
          UserIds: [],
          OfficeIds: [],
        }
      );
      const payload = {
        UserIds,
        OfficeIds,
        OwnerId: selectedId,
        IsActive: isActive,
      };
      const res = await staffRepository.bulkUpdateStatusActivateOrDeactivate(
        payload
      );
      if (res?.statusCode === 200) {
        toast.success(res.message);
        resetApi();
        setModalOpenForAll(null);
        modalSetter(null);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      loadingSetter(false);
    }
  };
  const removeStaff = async () => {
    loadingSetter(true);
    const { UserIds, OfficeIds } = [
      ...selectedDeactivated,
      ...selectedActivated,
    ].reduce(
      (prev, curr) => {
        prev.UserIds.push(curr.staffMemberId);
        prev.OfficeIds.push(curr.officeId);
        return prev;
      },
      {
        UserIds: [],
        OfficeIds: [],
      }
    );
    try {
      const payload = {
        UserIds,
        OwnerId: selectedId,
        OfficeIds,
        IsGlobal: globalStaffPage,
      };
      const res = await staffRepository.bulkRemove(payload);
      if (res?.statusCode === 200) {
        toast.success(res.message);
        resetApi();
        setModalOpenForAll(null);
        modalSetter(null);
      }
      setIsModalOpen(null);
    } catch (error) {
      toast.error(error.message);
    } finally {
      loadingSetter(false);
    }
  };
  const onAction = () => {
    if (isModalOpen === constants.staffActionEvents.deactivation) {
      activateDeactivateStaff(false);
    } else if (isModalOpen === constants.staffActionEvents.removal) {
      removeStaff();
    } else {
      setIsModalOpen(null);
    }
  };
  const onResendInviteOrNotifyClick = async (IsResendInvite) => {
    // IsResendInvite: true, for resend Invite
    // IsResendInvite: false, for re-notify
    loadingSetter(true);
    try {
      const payload = {
        OwnerId: selectedId,
        UserIds: IsResendInvite
          ? [
              ...selectedInvitationPending.map((res) => res.staffMemberId),
              ...selectedInvitationDeclined.map((res) => res.staffMemberId),
              ...selectedRemoved.map((res) => res.staffMemberId),
            ]
          : selectedInvitationPending.map((res) => res.staffMemberId),
        IsGlobal: globalStaffPage,
        ...(globalStaffPage ? {} : { OfficeId: officeIdDecode }),
        IsResendInvite: IsResendInvite,
      };
      const res = await staffRepository.renotifyPendingStaff(payload);
      if (res?.statusCode === 200) {
        toast.success(res.message);
        if (IsResendInvite && selectedRemoved.length > 0) {
          resetApi();
        }
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      loadingSetter(false);
    }
  };
  const [isModalOpenForFileUploadStatus, setIsModalOpenForFileUploadStatus] =
    useState(null);

  const handleFileUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file type
    const validExtensions = [
      ".xlsx",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const fileExtension = file?.name.split(".").pop()?.toLowerCase();

    const isValidFile =
      validExtensions.includes(`.${fileExtension}`) ||
      validExtensions.includes(file?.type);

    if (!isValidFile) {
      toast.error("Please select a valid XLSX file");
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      return;
    }

    loadingSetter(true);
    try {
      const ownerId = globalStaffPage ? selectedId : officeDetail?.ownerId;
      const res = await uploadStaffCsv(file, ownerId);

      if (res) {
        toast.success("File uploaded successfully");
        resetApi();
        setIsModalOpenForFileUploadStatus(res);
      }
    } catch (error) {
      setIsModalOpenForFileUploadStatus(error);
      toast.error(error.message || "Failed to upload file");
    } finally {
      loadingSetter(false);
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const notSelectedInvitationPending = selectedInvitationPending.length === 0;
  const notSelectedInvitationDeclined = selectedInvitationDeclined.length === 0;
  const notSelectedResendInvitationUser =
    notSelectedInvitationPending &&
    notSelectedInvitationDeclined &&
    selectedRemoved.length === 0;
  const notSelectedActivated =
    selectedActivated.length === 0 && selectedActivatedAdmin.length !== 1;
  const notSelectedDeactivated = selectedDeactivated.length === 0;
  const cannotRemoveAnyStaff =
    notSelectedDeactivated &&
    notSelectedActivated &&
    selectedActivatedAndDeactivate.length !== 1;
  const routeForDeactiveOrRemove = (search, id, officeId) => {
    history.push({
      pathname: constants.routes.staff.staffDetail,
      state: {
        detail: { userId: id },
        ownerId: selectedId,
        OfficeId: officeIdDecode || officeId,
      },
      search:search+(globalStaffPage&&selectedOwnerIdString?`&${selectedOwnerIdString}`:"")
    });
  };
  const activatedStaffForEdit = isOwner
    ? [...selectedActivated, ...selectedActivatedAdmin]
    : selectedActivated;
  const disableBulkUpdate =
    activatedStaffForEdit.length === 0 &&
    selectedInvitationPending.length === 0;

  const redirectionForEdit = () => {
    if (
      (activatedStaffForEdit.length === 1 &&
        selectedInvitationPending.length === 0) ||
      (activatedStaffForEdit.length === 0 &&
        selectedInvitationPending.length === 1)
    ) {
      const values = activatedStaffForEdit.length
        ? activatedStaffForEdit[0]
        : selectedInvitationPending[0];
      history.push({
        pathname: constants.routes.accountOwner.editStaff.replace(
          ":id",
          encodeId(values.officeId)
        ),
        state: {
          staffDetail: {
            staffMemberId: values.staffMemberId,
          },
          ownerId: selectedId,
        },
        search:globalStaffPage&&selectedOwnerIdString?`&${selectedOwnerIdString}`:""
      });
    } else if (globalStaffPage) {
      history.push({
        pathname:
          constants.routes.accountOwner.updateMultipleStaffForMultipleOffices,
        state: {
          userList: [...activatedStaffForEdit, ...selectedInvitationPending],
          ownerId: selectedId,
        },
        search:globalStaffPage&&selectedOwnerIdString?`&${selectedOwnerIdString}`:""
      });
    } else {
      history.push({
        pathname:
          constants.routes.accountOwner.updateMultipleStaffForSingleOffice,
        state: {
          userList: [...activatedStaffForEdit, ...selectedInvitationPending],
          officeId: +decodeId(officeId),
          ownerId: selectedId,
        },
        search:globalStaffPage&&selectedOwnerIdString?`&${selectedOwnerIdString}`:""
      });
    }
  };
  return (
    <div
      className={
        styles["staff-dropdown"] +
        " cursor-pointer " +
        styles["export-dropdown"]
      }
      onClick={toggle}
      ref={boxRef}
    >
      <Dropdown isOpen={isDropdownOpen} toggle={() => {}}>
        <DropdownToggle caret={false} tag="div">
          <span className="ico">
            <img
              src={require("assets/images/dots-icon.svg").default}
              alt="icon"
            />
          </span>
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem>
            <span onClick={() => downloadAllExportFile([allMembersValue])}>
              {t("staff.exportAllStaff")}
            </span>
          </DropdownItem>
          <DropdownItem>
            <span onClick={() => downloadAllExportFile()}>
              {t("staff.exportVisibleStaffOnly")}
            </span>
          </DropdownItem>
          <DropdownItem>
            <span onClick={handleFileUploadClick}>{t("staff.addUpdate")}</span>
          </DropdownItem>
          <DropdownItem>
            <span onClick={() => downloadAllExportFile("template")}>
              {t("staff.downloadTemplate")}
            </span>
          </DropdownItem>
          <DropdownItem disabled={disableBulkUpdate}>
            <span
              style={{
                opacity: disableBulkUpdate ? 0.4 : 1,
                cursor: disableBulkUpdate ? "not-allowed" : "pointer",
              }}
              onClick={redirectionForEdit}
            >
              {t("staff.bulkUpdate")}
            </span>
          </DropdownItem>
          <DropdownItem disabled={notSelectedInvitationPending}>
            <span
              style={{
                opacity: notSelectedInvitationPending ? 0.4 : 1,
                cursor: notSelectedInvitationPending
                  ? "not-allowed"
                  : "pointer",
              }}
              onClick={() => {
                onResendInviteOrNotifyClick(false);
              }}
            >
              {t("staff.renotify")}
            </span>
          </DropdownItem>

          <DropdownItem disabled={notSelectedResendInvitationUser}>
            <span
              style={{
                opacity: notSelectedResendInvitationUser ? 0.4 : 1,
                cursor: notSelectedResendInvitationUser
                  ? "not-allowed"
                  : "pointer",
              }}
              onClick={() => {
                onResendInviteOrNotifyClick(true);
              }}
            >
              {t("staff.resendInvite")}
            </span>
          </DropdownItem>
          <DropdownItem disabled={notSelectedActivated}>
            <span
              style={{
                opacity: notSelectedActivated ? 0.4 : 1,
                cursor: notSelectedActivated ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (
                  selectedActivatedAdmin.length === 1 &&
                  selectedActivated.length === 0
                ) {
                  routeForDeactiveOrRemove(
                    "?action=1",
                    selectedActivatedAdmin[0].staffMemberId,
                    officeIdDecode
                      ? officeIdDecode
                      : selectedActivatedAdmin[0].officeId
                  );
                } else if (selectedActivated.length === 1) {
                  setIsModalOpen(constants.staffActionEvents.deactivation);
                } else {
                  setModalOpenForAll("deactivate");
                }
              }}
            >
              {t("staff.deactivate")}
            </span>
          </DropdownItem>
          <DropdownItem disabled={cannotRemoveAnyStaff}>
            <span
              style={{
                opacity: cannotRemoveAnyStaff ? 0.4 : 1,
                cursor: cannotRemoveAnyStaff ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                if (
                  !globalStaffPage &&
                  selectedActivatedAndDeactivate.length === 0 &&
                  selectedActivatedAndDeactivateAllAdmins.length === 1
                ) {
                  routeForDeactiveOrRemove(
                    "?action=2",
                    selectedActivatedAndDeactivateAllAdmins[0].staffMemberId,
                    officeIdDecode
                      ? officeIdDecode
                      : selectedActivatedAndDeactivateAllAdmins[0].officeId
                  );
                } else if (selectedActivatedAndDeactivate.length === 1) {
                  modalSetter(constants.staffActionEvents.removal);
                } else {
                  setModalOpenForAll("remove");
                }
              }}
            >
              {t("staff.remove")}
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      {[
        constants.staffActionEvents.activation,
        constants.staffActionEvents.deactivation,
        constants.staffActionEvents.removal,
        constants.staffActionEvents.removalAsAdmin,
        constants.staffActionEvents.cancelInvitation,
        constants.staffActionEvents.multipleActivationConfirm,
      ].includes(isModalOpen) && (
        <StaffActionModal
          isOpen={true}
          event={isModalOpen}
          onAction={onAction}
          onClose={() => modalSetter(null)}
        />
      )}
      <ConfirmRemoveModal
        isOpen={modalOpenForAll === "remove"}
        toggle={() => setModalOpenForAll(null)}
        onConfirm={removeStaff}
        t={t}
        description="You are about to remove multiple staff members.Deactivated staff members will be permanently remove and no longer be associated with the office."
        confirmationText="Are you sure you want to remove multiple staff members?"
        title={"Remove Multiple Staff Members?"}
        btnText="Remove"
      />
      <ConfirmRemoveModal
        isOpen={modalOpenForAll === "deactivate"}
        toggle={() => setModalOpenForAll(null)}
        onConfirm={() => activateDeactivateStaff(false)}
        t={t}
        description="You are about to deactivate multiple staff members.
Deactivated staff members will no longer be associated with the office."
        confirmationText="Are you sure you want to deactivate multiple staff members?"
        title={"Deactivate Multiple Staff Members?"}
        btnText="Deactivate"
      />
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        style={{ display: "none" }}
      />
      {isModalOpenForFileUploadStatus && (
        <FailureSuccessRecordsModal
          isModalOpen={true}
          data={isModalOpenForFileUploadStatus}
          closeModal={() => setIsModalOpenForFileUploadStatus(null)}
        />
      )}
    </div>
  );
};

export default withTranslation()(StaffListingActions);
